import paymenttransferApi from '@/api/paymenttransfer';

const paymenttransfer = {
  state: {
    navTitle: '', //平台标题文字
    sourceClass: '', //平台css主题
    token: '', //登录认证信息
    orderData: {}, //订单信息
    // 订单状态
    orderResult: {},
    // 扫码支付按钮
    smzfBtnLDis: false,
    // 扫码支付两种方式按钮开关状态
    aliSM: [],
    qrImg: '',
    //支付宝扫码自动
    autoAlipay: false,
    //支付宝扫码支付二维码
    ImgData: "",
    pid: ''
  },
  mutations: {
    setNavTitle(state, title) {
      state.navTitle = title;
    },
    setSourceClass(state, className) {
      state.sourceClass = className;
    },
    setToken(state, token) {
      state.token = token;
    },
    setOrderData(state, data) {
      state.orderData = data;
    },

    // 订单详情
    setOrderResult(state, data) {
      state.orderResult = data;
    },
    setSmzfBtnLDis(state, flag) {
      state.smzfBtnLDis = flag;
    },
    setAliSM(state, data) {
      state.aliSM = data;
    },
    setQrImg(state, qrImg) {
      state.qrImg = qrImg;
    },
    setAutoAlipay(state, data) {
      state.autoAlipay = data;
    },
    setImgData(state, data) {
      state.ImgData = data;
    },
    setPid(state, pid) {
      state.pid = pid;
    }
  },
  actions: {
    getQuickPayment(param) {
      paymenttransferApi.GetAllQuickPaymentType(param).then(res => {

      })
    },
    // 获取订单详情
    async GetOrderDetailAc({ state, commit }, params) {
      try {
        let res = await paymenttransferApi.GetOrderDetail(params)
        if (res.data.success) {
          commit('setOrderResult', res.data.result)
        }
      } catch (err) {
        this.$toast(err.response.data.error.message);
      }
    },
    // 获取pid
    async GetPIDByOrderCodeAc({ state, commit }, params) {
      commit('setSmzfBtnLDis', true)
      try {
        let res = await paymenttransferApi.GetPIDByOrderCode({ orderCode: state.orderResult.orderCode })
        if (res.data.success) {
          if (res.data.result) {
            commit('setPid', res.data.result)
          }
        }
      } catch (err) {
        this.$toast(err.response.data.error.message);
      }
      commit('setSmzfBtnLDis', false)
    },
    // 扫码支付开关状态
    async GetAliPayJumpAliPayStatusAc({ state, commit }, { Device }) {
      let res = await paymenttransferApi.GetAliPayJumpAliPayStatus()
      try {
        if (res.data.success) {
          if (Device == 'ios') {
            commit('setAliSM', res.data.result.iOSStatus)
          } else if (Device == 'android') {
            commit('setAliSM', res.data.result.androidStatus)
          }
        }
      } catch (err) {
        this.$toast(err.response.data.error.message);
      }
    },

    async GetAllQuickPaymentTypeAc({ state, commit }, param) {
      try {
        let res = await paymenttransferApi.GetAllQuickPaymentType(param)
        if (res.data.success) {
          if (res.data.result.paymentType != 0) {
            commit('setQrImg', res.data.result.result.qrCode)
          }
        }
      } catch (err) {
        this.$toast(err.response.data.error.message);
      }
    },
    async DownloadQRCodeAc({ state, commit }, { params, Device, route }) {
      let res = await paymenttransferApi.DownloadQRCode(params)
      //1：支付宝扫码支付，2:手机银行APP扫码,4：支付宝转银行卡支付,5,:手机银行支付
      if (route.query.paymentType == 1 || route.query.paymentType == 4) { //支付宝扫码支付/支付宝转银行卡
        commit('setAutoAlipay', true)
      }
      if (route.query.from == "xsmcfx" || route.query.from == "jf24k") { //投资和钜丰
        commit('setImgData', res.data.result.split(",")[1])
      } else if (route.query.from == "xs9999") { //金业
        if (Device == "ios") {
          commit('setImgData', res.data.result.split(",")[1])
        } else if (Device == "android") {
          commit('setImgData', res.data.result)
        }
      }
    }
    // r.then(res => {
    //   if (res.data.success) {
    //     if (fn.getDevice() == 'ios' && !this.showQrCode) {
    //       this.aliSM = res.data.result.iOSStatus
    //     } else if (fn.getDevice() == 'android' && !this.showQrCode) {
    //       this.aliSM = res.data.result.androidStatus
    //     } else {
    //       this.aliSM = [false, true]
    //     }
    //   }
    // })
  }
};

export default paymenttransfer;


// WEBPACK FOOTER //
// ./src/store/modules/paymenttransfer.js